import { render, staticRenderFns } from "./nursing_care.vue?vue&type=template&id=ef0f0bf6&scoped=true&"
import script from "./nursing_care.vue?vue&type=script&lang=js&"
export * from "./nursing_care.vue?vue&type=script&lang=js&"
import style0 from "./nursing_care.vue?vue&type=style&index=0&id=ef0f0bf6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0f0bf6",
  null
  
)

export default component.exports